import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import toast from "react-hot-toast";
import { confirmAlert } from "react-confirm-alert";
import { useAtom } from "jotai";
import {
  gbState,
  globalUserStatus,
} from "../../../components/shared/GlobalState";
import { HiOutlineUserAdd, HiOutlineSearch, HiX, HiOutlineUser, HiCheck, HiOutlineBell } from 'react-icons/hi';

const BuddyRequestsSection = () => {
  const [{ errorLogApi, placeHolderText, Category, user }] = useAtom(gbState);
  const [userGlobal, setUserGlobal] = useAtom(globalUserStatus);
  const [buddies, setBuddies] = useState();
  const [updatedUser, setUpdatedUser] = useState();
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    let userToken = localStorage.getItem("token");
    const config = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/user/buddies-details`,
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
      data: { buddies: userGlobal?.buddyRequests },
    };

    axios(config)
      .then(function (response) {
        //toast.success("Request Sent Successfully.");

        setBuddies(response?.data);
      })
      .catch(function (error) {
        toast.error(error?.response?.data?.message);
        errorLogApi(error, "AssetInwardChild", "/asset/add");
        // console.log(error);
      });
  }, [userGlobal]);

  const updateUserDetailRealtime = () => {
    let userToken = localStorage.getItem("token");
    const config = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/user/refresh-user`,
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
      data: { userId: userGlobal?._id },
    };

    axios(config)
      .then(function (response) {
        //toast.success("Request Sent Successfully.");

        setUpdatedUser(response?.data);
        setUserGlobal({ ...userGlobal, ...response?.data });
      })
      .catch(function (error) {
        toast.error(error?.response?.data?.message);
        errorLogApi(error, "AssetInwardChild", "/asset/add");
        // console.log(error);
      });
  };

  // Filter buddies based on search
  const filteredBuddies = buddies?.filter((buddy) => {
    if (!searchQuery) return true;
    const fullName = `${buddy?.first_name} ${buddy?.last_name}`.toLowerCase();
    return fullName.includes(searchQuery.toLowerCase());
  });

  return (
    <div className="mt-6 bg-white rounded-xl shadow-sm">
      <div className="p-6">
        {/* Header Section */}
        <div className="flex justify-between items-center mb-6">
          <div className="flex items-center space-x-3">
            <div className="p-2 bg-indigo-50 rounded-lg">
              <HiOutlineBell className="w-6 h-6 text-indigo-600" />
            </div>
            <div>
              <h2 className="text-xl font-bold text-gray-900">Friend Requests</h2>
              <p className="text-xs text-gray-500">
                {buddies?.length || 0} pending requests
              </p>
            </div>
          </div>
        </div>

        {/* Search Section */}
        <div className="relative mb-6">
          <div className="flex absolute inset-y-0 left-0 items-center pl-3 pointer-events-none">
            <HiOutlineSearch className="w-5 h-5 text-gray-400" />
          </div>
          <input
            type="text"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="block py-2 pr-10 pl-10 w-full leading-5 placeholder-gray-400 bg-gray-50 rounded-md border border-gray-200 transition duration-150 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
            placeholder="Search requests..."
          />
          {searchQuery && (
            <button
              onClick={() => setSearchQuery("")}
              className="flex absolute inset-y-0 right-0 items-center pr-3 text-gray-400 transition-colors duration-200 hover:text-gray-600"
              title="Clear search"
            >
              <HiX className="w-5 h-5" />
            </button>
          )}
        </div>

        {/* Requests List */}
        <div className="space-y-4">
          {filteredBuddies && filteredBuddies.length > 0 ? (
            filteredBuddies.map((buddy) => (
              <RequestComponent
                key={buddy?._id}
                buddy={buddy}
                user={userGlobal}
                errorLogApi={errorLogApi}
                updateUserDetailRealtime={updateUserDetailRealtime}
              />
            ))
          ) : (
            <div className="py-8 text-center">
              <div className="inline-flex justify-center items-center w-16 h-16 bg-gray-100 rounded-full">
                <HiOutlineUserAdd className="w-8 h-8 text-gray-400" />
              </div>
              <h3 className="mt-4 text-sm font-medium text-gray-900">
                {searchQuery ? "No matching requests" : "No Pending Requests"}
              </h3>
              <p className="mt-1 text-sm text-gray-500">
                {searchQuery ? "Try adjusting your search terms" : "You're all caught up!"}
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const RequestComponent = ({
  buddy,
  user,
  errorLogApi,
  updateUserDetailRealtime,
}) => {
  let navigate = useNavigate();

  const acceptBuddy = (buddy_Id) => {
    let userToken = localStorage.getItem("token");
    const config = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/user/accept-buddy-request`,
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
      data: { userId: buddy_Id, requesterId: user?._id },
    };

    axios(config)
      .then(function (response) {
        updateUserDetailRealtime();
        toast.success("Buddy added Successfully.");
      })
      .catch(function (error) {
        toast.error(error?.response?.data?.message);
        errorLogApi(error, "AssetInwardChild", "/asset/add");
        // console.log(error);
      });
  };

  const acceptBuddyRequest = (id) => {
    confirmAlert({
      title: "Confirm Request",
      message: "Are you sure you want to accept this friend request?",
      buttons: [
        {
          label: "Accept",
          onClick: () => acceptBuddy(id),
          className: "bg-green-500 hover:bg-green-600 text-white"
        },
        {
          label: "Cancel",
          className: "bg-gray-500 hover:bg-gray-600 text-white"
        },
      ],
    });
  };

  return (
    <div className="relative p-4 bg-gray-50 rounded-lg transition-all duration-200 hover:bg-gray-100">
      {/* Action Buttons - Positioned Absolute Top Right */}
      <div className="flex absolute top-3 right-3 items-center space-x-2">
        <button
          onClick={() => acceptBuddyRequest(buddy?._id)}
          className="p-1.5 text-green-600 hover:text-green-700 hover:bg-green-50 rounded-full transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-green-500"
          title="Accept Request"
        >
          <HiCheck className="w-5 h-5" />
        </button>
        <button
          onClick={() => {}}
          className="p-1.5 text-gray-400 hover:text-gray-500 hover:bg-gray-50 rounded-full transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-gray-400"
          title="Decline Request"
        >
          <HiX className="w-5 h-5" />
        </button>
      </div>

      {/* Profile Content - Full Width */}
      <div className="flex items-center pr-32 space-x-4">
        <div className="flex-shrink-0">
          {buddy?.image ? (
            <img
              crossOrigin="anonymous"
              src={`${process.env.REACT_APP_REPORTS_DOWNLOAD_URL}uploads/family/${buddy?.image}`}
              className="object-cover w-12 h-12 rounded-full border-2 border-white shadow-sm"
              alt={`${buddy?.first_name}'s profile`}
            />
          ) : (
            <div className="flex justify-center items-center w-12 h-12 bg-gray-200 rounded-full">
              <HiOutlineUser className="w-6 h-6 text-gray-400" />
            </div>
          )}
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-sm font-medium text-gray-900 truncate">
            {buddy?.first_name} {buddy?.last_name}
          </h3>
          <p className="text-sm text-gray-500">Requesting to connect</p>
        </div>
      </div>
    </div>
  );
};

export default BuddyRequestsSection;
